import axios from 'axios'
import { Message } from 'element-ui'

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    //   withCredentials: true, 
    timeout: 20000,
    headers: {
        "Access-Control-Allow-Origin": '*'
    }
})
// request interceptor
service.interceptors.request.use(
    config => {
        config.headers.common['equipment'] = 'h5';
        config.headers.common['version'] = '1.0.0'
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        return Promise.reject(error)
    }
)

// 字典
export const getDicts = () => {
    return service.get('/dicts')
}

export const getDictsByType = (params) => {
    return service.get(`/dicts/type/${params}`)
}
// 分类
export const getCategoriesById = (params) => {
    return service.get(`/categories/${params}`)
}

export const getCategoriesByType = (params) => {
    return service.get(`/categories/type/${params}`)
}
// 资讯信息
export const getResourceNews = (params) => {
    return service.get(`/news`, { params })
}

export const getResourceNewsDetail = (params) => {
    return service.get(`/news/${params}`)
}

export const getResourceNewsRecently = (params) => { // params{size}
    return service.get(`/news/recently`, { params })
}

// 视频信息
export const getResourceVideos = (params) => {
    return service.get(`/videos`, { params })
}

export const getResourceVideosDetail = (params) => {
    return service.get(`/videos/${params}`)
}

export const getResourceVideosRecently = (params) => { // params{size}
    return service.get(`/videos/recently`, { params })
}

// 直播信息
export const getResourceLives = (params) => {
    return service.get(`/lives`, { params })
}

export const getResourceLivesDetail = (params) => {
    return service.get(`/lives/${params}`)
}

export const getResourceLivesRecently = (params) => { // params{size}
    return service.get(`/lives/recently`, { params })
}
export const getResourceLivesRecommended = (params) => { // params{size}
    return service.get(`/lives/recommended`, { params })
}
export const getResourceLivesHeatRanks = (params) => { // params{size}
    return service.get(`/lives/${params.id}/heat-ranks`,)
}

//专题
export const getResourceSubjects = (params) => {
    return service.get(`/subjects`, { params })
}

export const getResourceSubjectsDetail = (params) => {
    return service.get(`/subjects/${params}`)
}

//评论
export const getCommentsById = (params) => {
    return service.get(`/comments`, { params })
}

export const getCommentsByTypeById = (params) => {
    return service.get(`/comments/${params.type}/${params.id}`)
}
export const createComments = (params) => {
    return service.post(`/comments`, params);
}

// 历史记录
export const getHistories = () => {
    return service.get(`/histories`);
}

//搜索
export const getSearch = (params) => {
    return service.get(`/search`, { params });
}
export const getSearchHotWord = (params) => {
    return service.get(`/search/hot-words`, { params });
}

// 支付
// 收藏
// 点赞
// 用户
export const getUsersInfoByToken = (params) => {
    return service.get(`/users/info`, { params });
}
export const getUsersInfoByName = (params) => {
    return service.get(`/users/username`, { params });
}
export const getUsersInfoById = (id) => {
    return service.get(`/users/info/${id}`);
}
export const getUsersFansById = (id) => {
    return service.get(`/users/${id}/fans-number`);
}
// 登录认证
// 账号密码登录
export const login = (params) => {
    return service.post(`/auth/authorizes`, params);
}
// 第三方账号登录
export const otherLogin = (params) => {
    return service.get(`/auth/oauthLogin`, params);
}

export const getVersion = (params) => {
    return service.get('/versions', { params })
}

// 广告
export const getAdvertisements = (params) => {
    return service.get('/advertisements', { params })
}

export const getEmployees = (params) =>{
    return service.get('/employees',{params})
  }
  
  export const getPosters = (params) => {
    return service.get('/posters', { params })
}

export const getCategoriesPosters = (params) => {
    return service.get('/categories/posters', { params })
}

export const getCategoriesLabels = (params) => {
    return service.get('/categories/labels', { params })
}

//话题
export const getTopics = (params) => {
    return service.get(`/topics`, { params })
}

export const getTopicsHot = (params) => {
    return service.get('/topics/hot', { params })
}

export const getTopicsNews = (params) => {
    return service.get('/topics/news', { params })
}

export const getTopicsVideos = (params) => {
    return service.get('/topics/videos', { params })
}

export const getTopicsLives = (params) => {
    return service.get('/topics/lives', { params })
}
